// ── Sidebar resume-pill data source (M9.5 Phase 2, #1814) ───────────────────
//
// Reads the in-progress counter session (if any) from localStorage so the
// Sidebar can show a "COUNTING · N arrows" pill from anywhere in the app —
// mirroring useActiveRound()'s polling pattern in Sidebar.jsx. Also runs the
// overnight stale-auto-finish check once on mount, since the Sidebar is the
// one thing mounted persistently whenever the archer is signed in.
import { useEffect, useState } from "react";
import { loadSession, totalCount } from "./counterSession";
import { maybeAutoFinishStaleSession } from "./counterAutoFinish";

const POLL_MS = 3000; // same-tab localStorage writes don't fire the "storage" event

function summarize(archerId) {
  const session = loadSession(archerId);
  const count = totalCount(session);
  return count > 0 ? { count } : null;
}

export function useCounterResume(archerId) {
  const [summary, setSummary] = useState(() => summarize(archerId));

  useEffect(() => {
    let alive = true;
    setSummary(summarize(archerId));

    maybeAutoFinishStaleSession(archerId)
      .catch(() => {
        /* best-effort — the session stays put and is retried on the next mount */
      })
      .finally(() => {
        if (alive) setSummary(summarize(archerId));
      });

    function refresh() {
      if (alive) setSummary(summarize(archerId));
    }
    function onStorage(e) {
      if (e.key == null || e.key.startsWith("xring.counter.session.")) refresh();
    }
    window.addEventListener("storage", onStorage);
    const interval = setInterval(refresh, POLL_MS);
    return () => {
      alive = false;
      window.removeEventListener("storage", onStorage);
      clearInterval(interval);
    };
  }, [archerId]);

  return summary;
}
